import { ISpecializedCombo, useCombo } from "@hooks/useCombo";
import { KeyOfEnum } from "@utils/TypeHelpers";
import React from "react";
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import AccountBalanceOutlinedIcon from '@material-ui/icons/AccountBalanceOutlined';
import SvgIcon from "@material-ui/icons/LocalAtm";
import { ReactComponent as PixFilledIcon } from '@assets/pix-filled.svg';
import { useFaturaService } from "@services/FaturaService";
import { MenuItem } from "@material-ui/core";

export enum EnumFormaPagamento {
    None = 0,
    Caixa =  1,
    Transferencia = 2,
    Pix = 3,
    //CartaoCredito = 4,
    //CartaoDebito = 5,
    BoletoBancario = 6,
    //Saldo = 7,
    PixAutomatico = 8,
    BoletoAutomatico = 9,
    PixManual = 10
}

export default interface IFormaPagamento {
    formaPagamentoId: number,
    nome: string,
    ativo: string,
}

export type IComboFormaPagamento = ISpecializedCombo<IFormaPagamento> & {
    loadManuaisOptions: () => void    
};

export function useFormaPagamentoCombo (initialValue?: EnumFormaPagamento) : IComboFormaPagamento {
    const combo = useCombo<IFormaPagamento>({
        value: initialValue
    });

    const faturaService = useFaturaService();

    const createOptions = React.useCallback(() => {
        return combo.set.map((formaPagamento, index) => {
            return <MenuItem key={index} value={formaPagamento.formaPagamentoId}>{formaPagamento.nome}</MenuItem>
        });
    }, [combo.set]);

    const loadOptions = React.useCallback(() => {
        combo.load(faturaService.listarFormasPagamentoAtivas)
    }, [combo, faturaService.listarFormasPagamentoAtivas]);

    const loadManuaisOptions = React.useCallback(() => {
        combo.load(faturaService.listarFormasPagamentoManuaisAtivas)
    }, [combo, faturaService.listarFormasPagamentoManuaisAtivas]);

    return React.useMemo(() => ({
        ...combo, createOptions, loadOptions, loadManuaisOptions
    }), [combo, createOptions, loadOptions, loadManuaisOptions]);
}

export function useFormaPagamentoIcon () {
    const map : KeyOfEnum<EnumFormaPagamento, React.ReactNode> = React.useMemo(() => ({
        [EnumFormaPagamento.None]: "",
        [EnumFormaPagamento.Caixa]: <LocalAtmIcon />,
        [EnumFormaPagamento.Transferencia]: <AccountBalanceOutlinedIcon />,
        [EnumFormaPagamento.BoletoBancario]: <DescriptionOutlinedIcon />,
        [EnumFormaPagamento.Pix]: <SvgIcon><PixFilledIcon /></SvgIcon>,
        [EnumFormaPagamento.BoletoAutomatico]: <DescriptionOutlinedIcon />,
        [EnumFormaPagamento.PixAutomatico]: <SvgIcon><PixFilledIcon /></SvgIcon>,
        [EnumFormaPagamento.PixManual]: <SvgIcon><PixFilledIcon /></SvgIcon>
    }), []);

    return React.useMemo(() => map, [map]);
}